import { render } from "./BaseAvatar.vue?vue&type=template&id=48e1be1e&scoped=true"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"

import "./BaseAvatar.vue?vue&type=style&index=0&id=48e1be1e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e1be1e"]])

export default __exports__